const state = {
    breadArray: [],
    userInfo: null,
    imgHost: "//image.healthjd.com/da/",
};
  
export default state